var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60986 13.7624L7.93486 15.5624C8.23486 15.8624 8.90986 16.0124 9.35986 16.0124H12.2099C13.1099 16.0124 14.0849 15.3374 14.3099 14.4374L16.1099 8.96235C16.4849 7.91235 15.8099 7.01235 14.6849 7.01235H11.6849C11.2349 7.01235 10.8599 6.63735 10.9349 6.11235L11.3099 3.71235C11.4599 3.03735 11.0099 2.28735 10.3349 2.06235C9.73486 1.83735 8.98486 2.13735 8.68486 2.58735L5.60986 7.16235",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78516 13.7623V6.4123C1.78516 5.3623 2.23516 4.9873 3.28516 4.9873H4.03516C5.08516 4.9873 5.53516 5.3623 5.53516 6.4123V13.7623C5.53516 14.8123 5.08516 15.1873 4.03516 15.1873H3.28516C2.23516 15.1873 1.78516 14.8123 1.78516 13.7623Z",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3c4768ef275ee365c5408cfe73645564.svg";
export { ForwardRef as ReactComponent };